import { M8ProductDTO } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  idUser: number;
};

export const getProducts = async (params: Params): Promise<M8ProductDTO[]> => {
  const response = await customFetch(
    getM8AdminURL(`getProducts?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
